import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
} from '@mui/material';

import {
  CANCEL_ACTION_NAME,
  INTEGRALERT_CONNECT_ACTION_NAME,
  INTEGRALERT_DIALOG_TITLE,
  INTEGRALERT_GATEWAY_KEY_LABEL,
  INTEGRALERT_GATEWAY_KEY_PLACEHOLDER,
} from '../config/config';

type Props = {
  open: boolean;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: (sensorGatewayKey: string) => void;
};

export const IntegralertDialog = ({ open, isSaving, onClose, onConfirm }: Props) => {
  const [sensorGatewayKey, setSensorGatewayKey] = useState('');

  useEffect(() => {
    if (!open) setSensorGatewayKey('');
  }, [open]);

  const isValid = sensorGatewayKey.trim().length > 0;

  const handleConfirm = () => {
    if (!isValid || isSaving) return;
    onConfirm(sensorGatewayKey.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { width: 600 } }}>
      <DialogTitle>{INTEGRALERT_DIALOG_TITLE}</DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: '2rem' }}>
        <TextField
          autoFocus
          fullWidth
          label={INTEGRALERT_GATEWAY_KEY_LABEL}
          placeholder={INTEGRALERT_GATEWAY_KEY_PLACEHOLDER}
          value={sensorGatewayKey}
          onChange={(event) => setSensorGatewayKey(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') handleConfirm();
          }}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isSaving}>
          {CANCEL_ACTION_NAME}
        </Button>
        <Button variant="contained" onClick={handleConfirm} disabled={!isValid || isSaving}>
          {INTEGRALERT_CONNECT_ACTION_NAME}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
